
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-8eaac5a8&scoped=true!../../../../vue-loader/lib/selector?type=styles&index=0!./FlowerSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./FlowerSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-8eaac5a8!../../../../vue-loader/lib/selector?type=template&index=0!./FlowerSpinner.vue"),
  /* scopeId */
  "data-v-8eaac5a8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/FlowerSpinner.vue
// module id = 861
// module chunks = 1